import dataPhotos from '../../../../../assets/documents/dataPhotos.png';
import dataBanks from '../../../../../assets/documents/dataBanks.png';
import dataMoreBanks from '../../../../../assets/documents/dataMoreBanks.png';
import camera from '../../../../../assets/documents/camera.png';
import env from '../../../../../environment';
import errorModal from '../../../../../assets/documents/ErrorIconAfterbanks.png';
import psd2 from '../../../../../assets/documents/psd2.png';
import footerGibobs from '../../../../../assets/documents/footerGibobs.png';
import footerMobileDocs from '../../../../../assets/documents/footerMobileDocs.png';
import gifBank from '../../../../../assets/documents/gifBank.gif';
import { Divider, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AutomaticDocumentationNew } from 'mortgage-documents';
import { isMobileOnly } from 'react-device-detect';
const { Text } = Typography;

const AutomaticDocumentation = ({ userMortgageId, stage }) => {
	const { t } = useTranslation();
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				minHeight: 'calc(100vh - 64px)',
				background: '#FCFAF5'
			}}>
			<AutomaticDocumentationNew
				userMortgageId={userMortgageId}
				stage={stage}
				env={env}
				platform={'engel'}
				traceSadabdell={undefined}
				images={{
					dataPhotos,
					dataBanks,
					dataMoreBanks,
					errorModal,
					psd2,
					footerGibobs,
					footerMobileDocs,
					gifBank,
					camera
				}}
			/>
			{isMobileOnly ? (
				<div style={{ marginTop: 'auto', padding: '24px 0px', marginBottom: 55 }}>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
						<LockOutlined style={{ color: '#808080', fontSize: 14 }} />
						<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080', marginLeft: 8 }}>
							{t('doc.ourSecureInformation').replace(/:$/, '.')}
						</Text>
					</div>
					<Divider style={{ margin: 8 }} />
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<img src="/images/documents/banco_espana.svg" alt="Logo Banco de Españana" />
						<Text style={{ fontSize: 8, fontWeight: 400, color: '#808080', marginLeft: 6 }}>
							Certificada como Intermediaria
							<br />
							de Crédito Inmobiliario nº: D842
						</Text>
					</div>
				</div>
			) : (
				<div style={{ marginTop: 'auto', padding: '24px 0px' }}>
					<Divider style={{ marginBottom: 16 }} />
					<div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<LockOutlined style={{ color: '#808080', fontSize: 20 }} />
							<Text style={{ fontSize: 12, fontWeight: 400, color: '#808080' }}>
								{t('doc.ourSecureInformation')}
							</Text>
						</div>
						<img src="/images/documents/banco_espana.svg" alt="Logo Banco de Españana" />
						<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080' }}>
							Certificada como Intermediaria
							<br />
							de Crédito Inmobiliario nº: D842
						</Text>
					</div>
				</div>
			)}
		</div>
	);
};

export default AutomaticDocumentation;
